import React from 'react'
import { Modal,Label, ModalBody, Input, FormGroup, ModalHeader, Button, ModalFooter, Col, Row } from 'reactstrap'
import Spinner from 'react-bootstrap/Spinner';

const ModalDownloadFilePdfCsv = ({
  endDateInput,
  startDateInput,
  handleDate,
  startDate,
  isOpen,
  toggle,
  downloadCsvFile,
  downloadPdf,
  purchaserOrder,
  buttonLoading
}) => (
  <Modal isOpen={isOpen} toggle={toggle} backdrop="static" size="md">
    <ModalHeader className="custom_header_colourTwo " toggle={toggle}>{purchaserOrder ? "Select Date" : "Available Brands" }</ModalHeader>
    <ModalBody>
      <Row className="">
      {purchaserOrder &&
      <> 
      <Col md={6}>
              <FormGroup>
                <Label for='startDate' >Start date</Label>
                <Input type='date' id='startDate' pattern='\d{4}-\d{2}-\d{2}' innerRef={startDateInput} onChange={handleDate} style={{ height: '40px' }}/>
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for='endDate'>End date</Label>
                <Input type='date' id='endDate' pattern='\d{4}-\d{2}-\d{2}' innerRef={endDateInput} onChange={handleDate} min={startDate ? startDate : ''} 
                style={{ height: '40px' }}/>
              </FormGroup>
            </Col>
            </>
      }
      </Row>
      <Row className='d-flex align-items-center justify-content-center'>
        <Col md="6"  className="mb-3 mb-md-0">
        {
          buttonLoading ? 
          <Button className='btn btn-primaryTwo' disabled  onClick={downloadCsvFile}>
            
            Send Sales Report
            <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                        style={{marginLeft:"5px"}}
                      />
          </Button>
          :
          <Button className='btn btn-primaryTwo'  onClick={downloadCsvFile}>
           Send Sales Report
          </Button>
        }
          
        </Col>
        
      </Row>
    </ModalBody>
    <ModalFooter>
      <Button color="secondary" onClick={toggle}>Close</Button>{' '}
    </ModalFooter>
  </Modal>
)

export default ModalDownloadFilePdfCsv

